const paths = {
  root: "/",
  signIn: "/login",
  decider: "/decider",
  setupPassword: "/create-password/:email/:token",
  retainAccess: "/account-retention",
  verifyData: "/create-password/verify",
  selfRegistration: "/individual/registration",
  essentials: "/essentials",
  clarity: "/clarity",
  guidance: "/guidance",
  selfRegistrationPayment: "/individual/payment/:type",
  selfRegistrationPaymentSuccess: "/individual/payments-success",
  selfRegistrationPaymentFailed: "/individual/payments-failed",
  students: "/students/:folderIds?",
  studentsAdd: "/students/add",
  studentsEmptyFolder: "/students",
  school: "/school/",
  folders: "/folders",
  faq: "/faq",
  freeTestDashboard: "/individual",
  freeTestItem: "/individual/test/:type/:id",
  freeTestInstruction: "/individual/test-instruction/:type/:id",
  freeTestTraining: "/individual/training/:type/:id",
  freeTestTrainingFinished: "/individual/training-finished/:type/:id",
  userProfile: "/user-profile",
  interestInventoryResults: "/student/interest-inventory/results",
  careerDetails: "/student/careers/:id",
  studentDashboard: "/student",
  dashboardViewerAccess: "/dashboard-access",
  dashboardViewerAccessCareer: "/dashboard-access/careers/:id",
  dashboardPreview: "/dashboard-preview/:testAttemptId",
  dashboardPreviewCareer: "/dashboard-preview/:testAttemptId/careers/:id",
  tutorialPlayer: "/tutorial/watch/:videoId",
  academyDashboard: "/academy",
  videoPlayer: "/academy/watch/:videoId",
  tests: "/student/test/:type/:id",
  testInstruction: "/test-instruction/:type/:id",
  training: "/training/:type/:id",
  trainingFinished: "/training-finished/:type/:id",
  paymentSuccess: "/payments/success",
  paymentFailed: "/payments/fail",
  forgotPassword: "/forgot-password",
  feedback: "/feedback/:token/:testAttemptId",
  bookSession: "/book-session/:token",
  bookSessionFailure: "/book-session-failure",
  notFound: "*",
};

export default paths;
